import { Controller } from "remult";

@Controller("volunteer-org-activity-methods")
export class VolunteerOrgActivityMethods {}
